import MuiIconButton from "@mui/material/IconButton";
import type { IconButtonProps as MuiIconButtonProps } from "@mui/material/IconButton";

export type IconButtonProps = MuiIconButtonProps;

export function IconButton({ children, color, onClick, sx }: IconButtonProps) {
  return (
    <MuiIconButton onClick={onClick} color={color} sx={sx}>
      {children}
    </MuiIconButton>
  );
}
